import React from "react";
import { Accordion, Box, Flex, Grid, Stack, Text } from "@mantine/core";
import { useServicePlanStyles } from "../style";
import ServicePlanAccordion from "../ServicePlanAccordion";
import { IconChevronDown } from "@tabler/icons-react";

export const safetyMonitoringItems = [
  { name: "Supervision throughout the day" },
  { name: "Check resident every 3-4 Hrs at night" },
  { name: "Monitoring device" },
  { name: "Turn PRN to prevent breakdown" },
  { name: "APP Mattress Overlay" },
  { name: "Low Air loss Mattress" },
  { name: "Bed Alarm" },
  { name: "High/Low Bed" },
  { name: "Call bell/button" },
  { name: "Fall Mattress/Pad" },
];

export const cognitiveActivitiesItems = [
  { name: "TV" },
  { name: "Music" },
  { name: "Games/Cards" },
  { name: "Family Visits" },
  { name: "Walks" },
  { name: "Outdoors" },
  { name: "Stuffed Animals/Dolls" },
  { name: "Puzzles" },
  { name: "Reading" },
  { name: "Cell Phone" },
  { name: "Activity of choice" },
  { name: "Pre-planned activity" },
  { name: "Other" },
];

export const coordinationOfCareItems = [
  { name: "Home Health Nurse" },
  { name: "Hospice Nurse" },
  { name: "Physical Therapy" },
  { name: "Chaplin" },
  { name: "Social Worker" },
  { name: "Hospice CNA" },
  { name: "Occupational Therapy" },
  { name: "Other" },
];

export const familyRepCommunicationItems = [
  { name: "Daily" },
  { name: "Weekly" },
  { name: "Monthly" },
  { name: "As needed" },
];

// MEDICATION ADMINISTRATION AND TREATMENT

export const medicationAdministrationItems = [
  { name: "Medset are filled by Certified Care Givers, Managers or Nurses" },
  { name: "All Medication are documented whether they are given or refused" },
  {
    name: "Caregivers will monitor resident for side effects and report adverse events PRN",
  },
  { name: "Medications will be administered per physician order" },
  { name: "Caregiver will observe resident swallowing medication" },
  {
    name: "Medication will be placed in a cup, resident to put medication in mouth",
  },
  { name: "Medication placed directly in residents hand" },
  { name: "Medication placed in residents mouth by spoon" },
  {
    name: "Crush medication and mix with food of residents choice, spoon into mouth",
  },
  { name: "Crush medications mix with H2O, administer through G tube" },
  {
    name: "Blood sugar reading, monitoring and recording done by trained caregiver",
  },
  {
    name: "Wound care done by trained caregiver, home health or Hospice Nurse",
  },
  { name: "Catheter change done by Home Health or Hospice Nurse" },
  { name: "Psychotropic medications" },
  { name: "Medication administered how many times daily and PRN" },
];

export const cognitiveStatusItems = [
  { name: "Alert and Oriented" },
  { name: "Confused" },
  { name: "Dementia" },
  { name: "Depressed" },
  { name: "Forgetful" },
  { name: "Uncooperative" },
  { name: "Anxious" },
  { name: "Agitated" },
  { name: "Delusional" },
  { name: "Hallucinations" },
  { name: "Wandering" },
  { name: "Combative" },
  { name: "Exit Seeking" },
];

export const mobilityAmbulationTransferItems = [
  {
    name: "Mobility",
    subItems: [
      { name: "Independent" },
      { name: "Stand By assist" },
      { name: "Can't self propel" },
      { name: "Self Propels w/c" },
      { name: "Complete Bed Rest" },
      { name: "bed to w/c" },
    ],
  },
  {
    name: "Ambulation",
    subItems: [
      { name: "Independent" },
      { name: "Non-Ambulatory" },
      { name: "Stand by Assist" },
      { name: "1-2 CG ASSIST" },
      { name: "Uses Walker" },
    ],
  },
  {
    name: "Transfer",
    subItems: [
      { name: "Self transfer" },
      { name: "Assisted transfer x1" },
      { name: "Assisted transfer x2" },
      { name: "Standby Transfer" },
      { name: "Hoyer Lift" },
    ],
  },
  {
    name: "EXEMPT from evacuation drill/ order by PCP",
  },
];

// NURSING/MEDICAL INSTRUCTIONS

export const nursingMedicalInstructionsItems = [
  {
    name: "If blood sugar is less than 60 give immediate source of carbohydrate i.e. Juice, glucose gel etc.",
  },
  { name: "Elevate Feet When Sitting or in Bed" },
  { name: "Elevate Heels off Mattress when in Bed" },
  { name: "Encourage Purse Lip Breathing when short of Breath" },
  { name: "Encourage Deep Breathing/Coughing Every 2 hrs while Awake" },
  { name: "Report Unusual Cough, Sputum or breathing to Doctor ASAP" },
  { name: "Use draw sheet to move resident in Bed" },
  { name: "Provide Care Per Home Health or Hospice Agency Instructions" },
  { name: "Report any changes in resident condition to Agency Personnel" },
  { name: "Per Physician Orders by Professional Nurse" },
  { name: "Follow Seizure Protocol" },
  { name: "Follow Chest Pain Protocol" },
  { name: "Wound Care" },
  { name: "Elevate Head When in Bed" },
  { name: "Follow Bleeding Precaution" },
  { name: "Follow Oxygen Protocol" },
];

export const conditionsRequiringCaregiversItems = [
  { name: "Temp Greater than 101" },
  { name: "Pulse > 108 or < 56" },
  { name: "respirations greater than 36 less than 12" },
  { name: "Systolic BP Greater than 180 less than 80" },
  { name: "Diastolic BP Greater than 100 or less than 50" },
  { name: "Weight loss greater than 5 pounds in 1 month" },
  {
    name: "Weight gain greater 2 lbs in 24 hrs or greater than 5 lbs in 1 wk.",
  },
  { name: "Fasting blood sugar greater than 300 or less than 60" },
  { name: "Report unusual cough, sputum or breathing ASAP" },
  { name: "Oximeter reading less than 90%" },
  {
    name: "Report chest pain, unresolved swelling or fluid retention, unusual skin color, unusual pulse",
  },
  {
    name: "Report areas of skin which do not return to normal colour within 20 minutes of relieving pressure",
  },
  {
    name: "Report burning urination, Dark color, foul Odor, blood fever or other unusual symptoms",
  },
  { name: "Report any real or suspected head Injury ASAP" },
  { name: "Report and deformity or loss of motion to a joint ASAP" },
  { name: "Other" },
];

const CareAndSafetyStep = ({ data, onChange, view, errors }) => {
  const { classes } = useServicePlanStyles();

  const handleAccordionChange = (section, items) => {
    onChange({
      ...data,
      [section]: items,
    });
  };

  return (
    <Box className={classes.formSection}>
      <Accordion
        className={classes.accordionStyle}
        chevron={<IconChevronDown />}
        chevronPosition="right"
        chevronSize={20}
        variant="separated"
        defaultValue="careAndSafety"
      >
        <Accordion.Item value="careAndSafety">
          <Accordion.Control>Care and Safety</Accordion.Control>
          <Accordion.Panel>
            <Grid>
              <Grid.Col span={12} sm={6} md={4} lg={4}>
                <ServicePlanAccordion
                  title="Safety Monitoring"
                  items={safetyMonitoringItems}
                  selectedItems={data.safetyMonitoring || []}
                  onChange={(items) =>
                    handleAccordionChange("safetyMonitoring", items)
                  }
                  view={view}
                  CareAndSafetyStep={true}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={4} lg={4}>
                <ServicePlanAccordion
                  title="Cognitive Activities"
                  items={cognitiveActivitiesItems}
                  selectedItems={data.cognitiveActivities || []}
                  onChange={(items) =>
                    handleAccordionChange("cognitiveActivities", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={12} sm={6} md={4} lg={4}>
                <Flex direction="column" gap={18}>
                  <ServicePlanAccordion
                    title="Coordination of Care"
                    items={coordinationOfCareItems}
                    selectedItems={data.coordinationOfCare || []}
                    onChange={(items) =>
                      handleAccordionChange("coordinationOfCare", items)
                    }
                    view={view}
                  />
                  <ServicePlanAccordion
                    title="Family/Rep Communication"
                    items={familyRepCommunicationItems}
                    selectedItems={data.familyRepCommunication || []}
                    onChange={(items) =>
                      handleAccordionChange("familyRepCommunication", items)
                    }
                    view={view}
                  />
                </Flex>
              </Grid.Col>

              <Grid.Col span={12} sm={6} md={8} lg={8}>
                <ServicePlanAccordion
                  title="Medication Administration and Treatment"
                  items={medicationAdministrationItems}
                  selectedItems={data.medicationAdministration || []}
                  onChange={(items) =>
                    handleAccordionChange("medicationAdministration", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={12} sm={6} md={4} lg={4}>
                <ServicePlanAccordion
                  title="Cognitive Status"
                  items={cognitiveStatusItems}
                  selectedItems={data.cognitiveStatus || []}
                  onChange={(items) =>
                    handleAccordionChange("cognitiveStatus", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={12} sm={6} md={5} lg={5}>
                <ServicePlanAccordion
                  title="Mobility Ambulation Transfer"
                  items={mobilityAmbulationTransferItems}
                  selectedItems={data.mobilityAmbulationTransfer || []}
                  onChange={(items) =>
                    handleAccordionChange("mobilityAmbulationTransfer", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={12} sm={6} md={7} lg={7}>
                <ServicePlanAccordion
                  title="Nursing/Medical Instructions"
                  items={nursingMedicalInstructionsItems}
                  selectedItems={data.nursingMedicalInstructions || []}
                  onChange={(items) =>
                    handleAccordionChange("nursingMedicalInstructions", items)
                  }
                  view={view}
                />
              </Grid.Col>

              <Grid.Col span={12} sm={12} md={8} lg={8}>
                <ServicePlanAccordion
                  title="Conditions requiring caregivers to call Physcian"
                  items={conditionsRequiringCaregiversItems}
                  selectedItems={data.conditionsRequiringCaregivers || []}
                  onChange={(items) =>
                    handleAccordionChange(
                      "conditionsRequiringCaregivers",
                      items,
                    )
                  }
                  view={view}
                />
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
};

export default CareAndSafetyStep;
